<template>
    <div class="layout">
        <Layout class="layouts">
            <Sider hide-trigger :style="{height:($store.state.tableHight - 65) + 'px'}" class="rx-sider">
                <Side></Side>
            </Sider>
            <Layout>
                <headers></headers>
                <Content class="em-body" :style="{height:($store.state.tableHight - 65) + 'px'}">
                    <Row>
                        <Col span="24">
                            <div class="em-list-header">
                                <div class="em-list-header-search">
                                    <Input class="search-input" size="small" clearable v-model="search.title" placeholder="标题" />
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small"  v-model="search.project_id"  clearable filterable  placeholder="项目">
                                        <Option :value="item.project_id" v-for="(item,index) in projectList" :key="index">{{item.name}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small"  v-model="search.company_id"  clearable filterable  placeholder="供应商">
                                        <Option :value="item.company_id" v-for="(item,index) in companyList" :key="index">{{item.company}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small"  v-model="search.product"  clearable filterable  placeholder="采购产品">
                                        <Option :value="item.b_id" v-for="(item,index) in productList" :key="index">{{item.name}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small"  v-model="search.head_id"  clearable filterable  placeholder="负责人">
                                        <Option :value="item.admin_id" v-for="(item,index) in userList" :key="index">{{item.real_name}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select size="small" v-model="search.status" clearable filterable placeholder="状态" class="search-select">
                                        <Option :value="item.id" v-for="(item,index) in statusList" :key="index">{{item.name}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Button size="small" @click="onSearch"><Icon type="ios-search" /> 搜索</Button>
                                </div>
                                <div class="rx-list-header-btn">
                                    <ButtonGroup >
                                        <Button type="primary" size="small" class="text-font-sm" @click="createData"><Icon type="md-add" /> 创建采购</Button>
                                        <Button type="warning" size="small" class="text-font-sm" @click="reSet"><Icon type="md-refresh" /> 刷新</Button>
                                    </ButtonGroup>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col span="24">
                            <Table row-key="id" ref="selection" stripe border :loading="$store.state.loading" :columns="columns" :data="dataList.data" no-data-text="暂无数据记录">
                                <template #title="{ row }">
                                    <div class="d-width text-primary cursor" :title="row.title">
                                        <span>{{row.title}}</span>
                                    </div>
                                </template>
                                <template #buyer_money="{ row }">
                                    <div class="d-width" :title="row.buyer_money?row.buyer_money:'0.00'">
                                        <strong class="text-primary">{{row.buyer_money?row.buyer_money:'0.00'}}</strong>
                                    </div>
                                </template>
                                <template #pay_money="{ row }">
                                    <div class="d-width" :title="row.pay_money?row.buyer_money:'0.00'">
                                        <strong class="text-violet">{{row.pay_money?row.pay_money:'0.00'}}</strong>
                                    </div>
                                </template>
                                <template #use_money="{ row }">
                                    <div class="d-width" :title="row.use_money?row.use_money:'0.00'">
                                        <strong class="text-success">{{row.use_money?row.use_money:'0.00'}}</strong>
                                    </div>
                                </template>
                                <template #product="{ row }">
                                    <Poptip trigger="hover" width="360" :word-wrap="true" title="产品价格：" >
                                        <div class="d-width">
                                            <Tag v-for="(item,index) in row.product_list" :key="index">{{item.name}}</Tag>
                                        </div>
                                        <template #content>
                                            <p v-for="(item,index) in row.proList" :key="index" style="white-space: normal;">{{item.product_name}}：单价：{{item.price}}， 数量：{{item.num}}</p>
                                        </template>
                                    </Poptip>

                                </template>
                                <template #status="{ row }">
                                    <Badge v-if="row.status === 1 || row.status === 2 || row.status === 3" color="blue" :text="row.status_name" />
                                    <Poptip v-else-if="row.status === 4" trigger="hover" width="240" :word-wrap="true" title="驳回原因：" >
                                        <Badge color="red" :text="row.status_name" />
                                        <template #content>
                                            <p style="white-space: normal;">时间：{{row.reject_time}}</p>
                                            <p style="white-space: normal;">原因：<span class="text-danger">{{row.reject_remark}}</span></p>
                                        </template>
                                    </Poptip>
                                    <Badge v-else-if="row.status === 5" color="green" :text="row.status_name"  />
                                    <Badge v-else-if="row.status === 6" color="orange" :text="row.status_name"  />
                                    <Badge v-else status="warning" text="其他" />
                                    <span  v-if="row.status === 5 && row.use_money <= 0" class="text-danger">,未支出</span>
                                </template>
                                <template #action="{ row, index }">
                                    <a class="text-font-sm text-orange" v-if="($store.state.userinfo.group_id == 1 || $store.state.userinfo.group_id == 2) && (row.status === 1 || row.status === 2)" @click="examineData(row.buyer_id, row.title)">审批</a>
                                    <Divider v-if="($store.state.userinfo.group_id == 1 || $store.state.userinfo.group_id == 2) && (row.status === 1 || row.status === 2)" type="vertical"/>
                                    <a class="text-font-sm text-primary" @click="editData(row.buyer_id)">编辑</a>
                                    <Divider type="vertical"/>
                                    <a class="text-font-sm text-999" @click="delData(row.buyer_id , index)">删除</a>
                                </template>
                            </Table>
                            <div class="em-page em-flex">
                                <Page size="small" :total="dataList.total" :current="page" :page-size="pageSize" show-total @on-change="changePage" />
                            </div>
                        </Col>
                    </Row>

                    <!-- 创建/编辑  -->
                    <add-modal v-if="is_create" ref="AddRef" @trueHandler="saveData"></add-modal>

                    <!-- 审批  -->
                    <examine-modal v-if="is_examine" ref="ExamineRef" @trueHandler="saveData"></examine-modal>

                </Content>
            </Layout>
        </Layout>
    </div>
</template>

<script>
import '@/assets/style.css'
import Headers from "@/components/public/Headers";
import Side from "@/components/public/Side";
import AddModal from "../Create";
import ExamineModal from "../Examine.vue";
import {deleteBuyer, getBuyerConfig, getBuyerList} from "@/apis/buyer";
import expandRow from "../Expand.vue";
export default {
    name: "BuyerIndex",
    components: {
        Headers, Side, AddModal, ExamineModal
    },
    data () {
        return {
            projectList: [],
            companyList: [],
            productList: [],
            userList: [],
            statusList: [],


            search: {
                title: '',
                project_id: '',
                company_id: '',
                product: '',
                head_id: '',
                status: ''
            },
            page : 1,
            pageSize : 15,
            selectCount  : 0,
            dataList : [],
            columns: [
                {
                    type: 'expand',
                    width: 50,
                    render: (h, data) => {
                        return h(expandRow, {
                            ref: `projectView_${data.index}`,
                            rowData: data.row, // 传参
                            onReloadData:(project_id) => {
                                let that = this;
                                //确保dom更新完成
                                this.$nextTick(() => {
                                    that.getListRefresh(project_id);
                                })
                            }
                        })
                    }
                },
                {
                    title: '标题',
                    key: 'title',
                    slot: 'title',
                    minWidth: 200,
                },
                {
                    title: '预采金额',
                    key: 'buyer_money',
                    slot: 'buyer_money',
                    width: 120,
                },
                {
                    title: '合同金额',
                    key: 'pay_money',
                    slot: 'pay_money',
                    width: 120
                },
                {
                    title: '已采金额',
                    key: 'use_money',
                    slot: 'use_money',
                    width: 120
                },
                {
                    title: '采购产品',
                    key: 'product',
                    slot: 'product',
                    width: 200
                },
                {
                    title: '状态',
                    key: 'status',
                    slot : 'status',
                    width:160
                },
                {
                    title: '负责人',
                    key: 'head_name',
                    width:120
                },
                {
                    title: '更新',
                    key: 'update_time',
                    width:150
                },
                {
                    title: '操作',
                    key: 'action',
                    slot : 'action',
                    // align: 'center',
                    width : 150,
                    // fixed : 'right'
                }
            ],
            is_create : false,
            is_examine : false,

        }
    },
    created(){
        this.getConfig();
        this.getList();
    },
    mounted(){
        let that = this;
        that.HeightInit();
    },
    computed: {

    },
    methods: {
        /**
         功能：
         time: 2026/1/6 11:06
         **/
        examineData(buyer_id, title){
            let that = this;
            that.is_examine = true;
            setTimeout(function(){
                that.$refs.ExamineRef.show(buyer_id, title);
            })
        },

        /**
         功能：搜索
         time: 2025-15-02 16:15:50
         **/
        onSearch(){
            let that = this;
            that.page = 1;
            that.getList();
        },
        /**
         功能：刷新
         time: 2025-17-02 16:17:18
         **/
        reSet(){
            let that = this;
            that.page = 1;
            that.search = {
                title: '',
                project_id: '',
                company_id: '',
                product: '',
                head_id: '',
                status: ''
            };
            that.getList();
        },
        /**
         功能：
         time: 2025-59-03 14:59:45
         **/
        getConfig(){
            let that = this;
            getBuyerConfig().then(e=>{
                that.projectList = e.data.projectList ?? [];
                that.companyList = e.data.companyList ?? [];
                that.productList = e.data.productList ?? [];
                that.userList = e.data.userList ?? [];
                that.statusList = e.data.statusList ?? [];
            })
        },
        /**
         功能：列表
         time: 2025-09-01 18:09:28
         **/
        getList(){
            let that = this;
            const params = {
                pageSize : that.pageSize,
                page : that.page,
                search : that.search
            };
            that.$store.commit('SET_LOADING' , true);
            getBuyerList(params).then(e=>{
                that.dataList = e.data;
                that.selectCount = 0;
            })
        },
        /**
         功能：Expand修改触发刷新
         time: 2025/12/26 09:55
         **/
        getListRefresh(buyer_id){
            let that = this;
            const params = {
                pageSize : that.pageSize,
                page : that.page,
                search : that.search
            };
            that.$store.commit('SET_LOADING' , true);
            getBuyerList(params).then(e=>{
                that.dataList = e.data;
                that.selectCount = 0;
                that.dataList.data.forEach((item, index) => {
                    if(parseInt(item.buyer_id) === parseInt(buyer_id)){
                        that.dataList.data[index]._expanded = true; //展开选中的行
                    }
                })
            })
        },
        /**
         功能：分页
         time: 2025-54-03 09:54:43
         **/
        changePage (e) {
            let that = this;
            that.page = e;
            that.getList();
        },

        /**
         功能：创建
         time: 2025-26-02 09:26:21
         **/
        createData(){
            let that = this;
            that.is_create = true;
            setTimeout(function(){
                that.$refs.AddRef.add();
            })
        },
        /**
         功能：编辑
         time: 2025-26-02 09:26:29
         **/
        editData(buyer_id){
            let that = this;
            that.is_create = true;
            setTimeout(function(){
                that.$refs.AddRef.edit(buyer_id);
            })
        },

        /**
         功能：操作返回
         time: 2025-26-02 09:26:53
         **/
        saveData(){
            let that = this;
            that.getList();
        },

        /**
         功能：
         time: 2026/1/6 09:23
         **/
        delData(buyer_id){
            let that = this;
            if(!buyer_id){
                that.$Message.error({ background: true,duration:3, content:'记录不存在'});
                return;
            }
            that.$Modal.confirm({
                title: '删除记录',
                content: '此操作将删除记录不可恢复, 是否继续?',
                onOk: () => {
                    deleteBuyer(buyer_id).then( e =>{
                        that.$Message.success({ background: true,duration:3, content:e.msg});
                        that.getList();
                    })
                },
                onCancel: () => {}
            });
        },
        HeightInit(){
            this.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            // 动态计算 table 的高度重新赋值
            const that = this;
            window.onresize = function () {
                that.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            }
        }
    }
}
</script>

<style scoped lang="less" rel="stylesheet/less">

</style>
